import { useMutation, useQueryClient } from "@tanstack/react-query";
import { alertService } from "../../../services/alertsService";
import type { Alert } from "../../../types";

export const useUpdateAlert = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      alertId,
      alert,
    }: {
      alertId: string;
      alert: Partial<Omit<Alert, "id">>;
    }) => {
      const updated = await alertService.patch(alertId, alert);
      return { updated, alertId };
    },
    onSuccess: ({ updated, alertId }) => {
      qc.setQueryData(["alert", updated.id], updated);
      qc.invalidateQueries({ queryKey: ["alert", alertId] });
      qc.invalidateQueries({ queryKey: ["alerts"] });
    },
  });
};
